import React from "react";

const Contact = () => {
  return (
    <div className='content'>
      Department of Software Engineering <br />
      Cankaya University <br />
      Email : mserkancinar@cankaya.edu.tr
    </div>
  );
};

export default Contact;
